<template>
    <div class="programme">
        <navs></navs>
        <div class="banner">
            <banner :img="bannerImg" titleEn="Social security scheme" titleCn="社保方案"></banner>
        </div>
        <div id="zzz"></div>
        <div class="calculator">
            <div class="all_box">
                <div class="calculator_title">
                    <h3>社保计算器</h3>
                    <p>本计算器帮助用户计算五险一金的缴费金额各险种缴费</p>
                    <p>基数上下缴费城市具体政策为准，每年当地社平工资的基数调整</p>

                    <el-select v-model="dataForm.sbId" placeholder="请输入内容" class="sbjsq_input" filterable>
                        <el-option v-for="item in sbList" :key="item.id" :label="item.title" :value="item.id">
                        </el-option>
                    </el-select>


                    <div class="btn_box">
                        <div class="chongzhi" @click="dataForm.sbId = ''">重置</div>
                        <div class="lijichazhao" @click="getSbDetailSelect">立即查找</div>
                    </div>
                </div>

                <div class="calculator_list">
                    <div class="calculator_item" v-for="item in sbList" @click="getSbDetail(item.id)">
                        {{item.title}}
                    </div>
                </div>
                <div class="calculator_detail">
                    <h3>{{detailData.title}}</h3>
                    <div class="detail_img">
                        <img :src="detailData.imageUrl">
                    </div>
                </div>
            </div>
        </div>
        <friend></friend>
        <foots @navChange="initDw"></foots>
    </div>
</template>
<script>
    import friend from '@/components/friend.vue'
    import banner from '@/components/banner.vue'
    import navs from '@/components/navs.vue'
    import foots from '@/components/foots.vue'
    import bannerImg from '@/assets/img/programme_banner.png'
    export default {
        name: 'programme',
        data() {
            return {
                bannerImg: bannerImg,
                //社保详情
                detailData: {},
                //社保列表
                sbList: [],
                dataForm: {
                    sbId: ''
                }
            }
        },

        mounted() {
            this.getSbList()
            this.initDw()
        },

        methods: {
            initDw() {
                if (this.$route.params.sbId) {
                    this.dataForm.sbId = this.$route.params.sbId
                    this.getSbDetailSelect()
                    document.getElementById("zzz").scrollIntoView();
                } else {
                    window.scrollTo(0, 0);
                }
            },
            //获取详情(通过筛选查询)
            getSbDetailSelect() {
                if (this.dataForm.sbId) {
                    this.$http.get(`/attract_investment/front/show/getNewsDetail/${this.dataForm.sbId}`).then(({
                        data: res
                    }) => {
                        this.detailData = res
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: '请输入关键字后查询。',
                        type: 'warning'
                    });
                }

            },


            //获取详情(直接点击列表)
            getSbDetail(id) {
                this.$http.get(`/attract_investment/front/show/getNewsDetail/${id}`).then(({
                    data: res
                }) => {
                    this.detailData = res
                })
            },
            //获取列表
            getSbList() {
                let data = {
                    page: 1,
                    limit: 10000,
                    categoryId: '1628268343981793281',
                }
                this.$http.get(`/attract_investment/front/show/newsList`, {
                    params: {
                        ...data
                    }
                }).then(({
                    data: res
                }) => {
                    this.sbList = res.list
                })
            },
        },
        components: {
            navs,
            foots,
            banner,
            friend
        }
    }
</script>
<style lang="scss" scoped>
    .detail_img img {
        width: 100%;
    }

    .calculator {
        padding-bottom: 100px;
    }

    .calculator_list {
        padding-bottom: 52px;
        border-bottom: 1px solid #eee;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-top: 25px;

        .calculator_item {
            width: 14%;
            font-size: 18px;
            color: #666;
            margin: 25px 0;
            cursor: pointer;
        }
    }


    .btn_box {
        width: 600px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .chongzhi {
            cursor: pointer;
            width: 210px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            border: 1px solid #999;
            border-radius: 60px;
            background: #fff;
            font-size: 18px;
            color: #333;
        }

        .lijichazhao {
            cursor: pointer;
            width: 350px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            border: 1px solid #F08300;
            border-radius: 60px;
            background: #F08300;
            color: #fff;
            font-size: 18px;
        }

    }


    .sbjsq_input {
        margin: 47px 0 31px;
    }

    .calculator_title {
        padding-bottom: 85px;
        border-bottom: 1px solid #eee;

        h3 {
            font-size: 36px;
            font-weight: 700;
            color: #333;
        }

        p {
            margin: 0;
            line-height: 30px;
            font-weight: 400;
            font-size: 16px;
            color: #999;
        }
    }

    .calculator_detail {
        padding-top: 48px;

        h3 {
            font-size: 26px;
            color: #333;
            font-weight: 700;
            margin: 0;
            margin-bottom: 18px;
        }
    }
</style>
<style lang="scss">
    .calculator_title {
        .el-input__inner {
            width: 600px;
            background: #F3F3F3;
        }
    }
</style>